<template>
  <div class="relative focus:outline-none xl:w-32 w-32 mr-3">



    <select :value="modelValue" @change="handleChange"
      class="cursor-pointer shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height">
      <optgroup v-if="options.includes('Weight')" label="Weight">
        <!-- <option>Pound</option> -->
        <option>Ounce</option>
        <option>Gram</option>
        <option>LB</option>
        <option>Kilogram</option>
        <option>Milligram</option>
      </optgroup>

      <optgroup v-if="options.includes('Volume')" label="Volume">
        <option>Gallon</option>
        <option>Quart</option>
        <option>Pint</option>
        <option>Cup</option>
        <option v-if="checkIsFluidOuncePresent()">Fluid Ounce</option>
        <option>Tablespoon</option>
        <option v-if="checkIsUnitPresent()">Litre</option>
        <option v-if="checkIsUnitPresent()">Millilitre</option>
        <option>Teaspoon</option>
      </optgroup>

      <optgroup v-if="options.includes('Unit')" label="Unit">
        <!-- <option>Piece</option> -->
        <!-- <option>Qty</option> -->
        <option>Each</option>
        <option>Count</option>
        <option>Piece</option>
      </optgroup>
      <optgroup v-if="convertCustom() && convertCustom().length > 0" label="Other">
        <option v-for="other in convertCustom()" :value="other.description1" :class="other.is_usda ? '' : ''">{{  other.is_usda ? '^ ' : '&nbsp;&nbsp;&nbsp;&nbsp;' }}{{
          other.description }}
        </option>
      </optgroup>
    </select>


    <!-- <div v-if="isCustomUnit" class="absolute right-10 top-[9px] text-xs font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer" @click="resetFromCustomUnit">[X]</div> -->

    <div
      class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
      <i class="fa fa-sort-desc arrow-size" aria-hidden="true"></i>
    </div>

  </div>
</template>

<script>
export default {
  props: [
    "selectedCustomUnitOfMeasurement",
    "preferred_product_information",
    "modelValue",
    "otherProp",
    "value",
    "options",
    "cuom",
    "isCustomUnit",
    "cuoms",
  ],
  name: "UomDropdown",
  mounted() {
    console.log('mounted.value', this.modelValue)
    console.log('mounted.options', this.options)
  },
  data() {
    return {
      choice: this.modelValue
    }
  },
  methods: {
    checkIsFluidOuncePresent() {      
        // First condition: Check selected unit
        if (
            this.selectedCustomUnitOfMeasurement && this.$helpers.uomType(this.selectedCustomUnitOfMeasurement.unit_type) === 'Volume' 
        ) {
            if(['Fluid Ounce'].includes(this.selectedCustomUnitOfMeasurement.unit_type)){
                return true;
            }
            return false;
        }
        // Second condition: Check preferred product information
        if (this.preferred_product_information) {
            const uomType = this.$helpers.uomType(this.preferred_product_information.nutrition_facts_volume_uom);
            return this.preferred_product_information.nutrition_facts_volume > 0 && ['Fluid Ounce'].includes(this.preferred_product_information.nutrition_facts_volume_uom);
        }

        return true;
    },
    checkIsUnitPresent() {      
        // First condition: Check selected unit
        if (
            this.selectedCustomUnitOfMeasurement && this.$helpers.uomType(this.selectedCustomUnitOfMeasurement.unit_type) === 'Volume'
        ) {
          if(['Millilitre', 'Litre'].includes(this.selectedCustomUnitOfMeasurement.unit_type)){
                return true;
            }
            return false;
        }

        // Second condition: Check preferred product information
        if (this.preferred_product_information) {
            const uomType = this.$helpers.uomType(this.preferred_product_information.nutrition_facts_volume_uom);
            // return this.nutrition_facts_volume > 0 && uomType === 'Volume';
            return this.preferred_product_information.nutrition_facts_volume > 0 && ['Millilitre', 'Litre'].includes(this.preferred_product_information.nutrition_facts_volume_uom);
        }

        return true;
    },
    convertCustom() {
      let custom = [];

      console.log("cuoms ", this.cuoms);

      // console.log("isCustomUnit ", this.isCustomUnit, this.cuoms, this.options, this.options.includes('Volume'));

      if (this.isCustomUnit) {
        if (this.cuoms && this.cuoms.length > 0) {
          for (var i = 0; i < this.cuoms.length; i++) {
            let unit_type = this.$helpers.uomType(this.cuoms[i].unit_type);
            if (unit_type == 'Custom') {
              unit_type = 'Unit';
            }
            console.log("isCustomUnit in ", unit_type, this.$helpers.uomType(this.cuoms[i].unit_type), this.cuoms[i].unit_type, this.options, this.options.includes(unit_type));
            if (this.cuoms[i].description && this.cuoms[i].description != '' && this.options.includes(unit_type))
              custom.push(this.cuoms[i]);
          }
        }
      } else {
        if (this.cuom && this.cuom.length > 0) {
          for (var i = 0; i < this.cuom.length; i++) {
            if (this.cuom[i].description && this.cuom[i].description != '')
              custom.push(this.cuom[i]);
          }
        }
      }

      return custom;
    },
    handleChange(event) {
      // console.log('handleChange', event);
      console.log('handleChange', event.target.value);
      // this.$emit('input', event.target.value)
      // this.$emit('change', event.target.value)
      this.$emit('update:modelValue', event.target.value)
      this.$emit('multipleUomForIngredients');

    },
    resetFromCustomUnit() {
      console.log('resetFromCustomUnit');
      //   this.$emit('update:modelValue', '');


      this.$emit('resetCustomUnit');
    }
  }
}
</script>

<style scoped>
.arrow-size {
  font-size: 35px;
  padding-bottom: 12px;
  cursor: pointer;
}
</style>
